
<div>
    <button style="margin-bottom: 5px; cursor: pointer;" type="button" class="btn btn-primary" routerLink="/categorias/cadastro" >Cadastrar</button>
    
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Nome</th>
                  <th scope="col">Descrição</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let categoria of categorias; let i = index">
                  <td>{{categoria.name}}</td>
                  <td>{{categoria.desc}}</td>
                  <td style="min-width: 120px;">
                    <button (click)="goToCategoryDetails(categoria.id)" style="margin-right: 10px;" type="button" class="btn btn-primary"><i class="far fa-eye"></i></button>
                    <button (click)="deleteCategory(categoria.id)"type="button" class="btn btn-danger"><i class="far fa-trash-alt"></i></button>
                  </td>
                </tr>           
              </tbody>
            </table>
          </div>
        </div>
      </div>